document.addEventListener('alpha.loaded', (e) => {
  const loaderEl = document.querySelector('.site-loader')
  if (loaderEl) {
    document.body.classList.remove('loading')
    loaderEl.classList.add('hiding')
    const loaderRemovalTimeout = 1000
    setTimeout(() => loaderEl.remove(), loaderRemovalTimeout)
  }
})
